import { useMemo } from 'react';
import { VirtualizationResult } from './types';

export const useVirtualization = (
  itemCount: number,
  itemSize: number,
  containerSize: number,
  scrollOffset: number,
  overscrollBuffer: number = 5
): VirtualizationResult => {
  return useMemo(() => {
    // Calculate which items are actually visible in the container
    const visibleStartIndex = Math.floor(scrollOffset / itemSize);
    const visibleEndIndex = Math.min(
      itemCount - 1,
      Math.floor((scrollOffset + containerSize) / itemSize)
    );

    // Apply buffer symmetrically
    const startIndex = Math.max(0, visibleStartIndex - overscrollBuffer);
    const endIndex = Math.min(
      itemCount - 1,
      visibleEndIndex + overscrollBuffer
    );

    const visibleCount = endIndex - startIndex + 1;

    return {
      startIndex,
      endIndex,
      visibleCount,
      offsetY: startIndex * itemSize,
      totalHeight: itemCount * itemSize,
    };
  }, [itemCount, itemSize, containerSize, scrollOffset, overscrollBuffer]);
};
